"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuality = exports.setQuality = void 0;
const defaultValue = undefined;
let quality = defaultValue;
const setQuality = (q) => {
    if (typeof q !== 'undefined' && typeof q !== 'number') {
        throw new Error(`Quality option must be a number or undefined. Got ${typeof q} (${JSON.stringify(q)})`);
    }
    if (q === 0 || q === undefined) {
        quality = defaultValue;
        return;
    }
    if (q > 100 || q < 0) {
        throw new Error('Quality option must be between 1 and 100.');
    }
    quality = q;
};
exports.setQuality = setQuality;
const getQuality = () => quality;
exports.getQuality = getQuality;
//# sourceMappingURL=quality.js.map